"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.function.name");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.renderBmVariableForm = exports.registerBmVariableFormElement = exports.NewRowModalElement = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _splice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/splice"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createForOfIteratorHelper"));

var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/entries"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var dotProp = _interopRequireWildcard(require("dot-prop-immutable"));

var _uiElements = require("@blue/ui-elements");

var _element = require("@blue/element");

var _bmFormEvents = require("../../bm-form-events");

var _itemRenderer = require("../item-engine/item-renderer");

var _renderLayout = require("../../layouts/render-layout");

var _variableFormFactory = require("./variable-form-factory");

var _bmFormValues = require("../../bm-form-values");

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)([" <bm-variable-form .info=\"", "\"></bm-variable-form> "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t\t:host footer {\n\t\t\t\t\tpadding-top: 20px;\n\t\t\t\t}\n\t\t\t"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<slot></slot>\n\t\t\t<footer>\n\t\t\t\t<button class=\"bm-button primary md\"\n\t\t\t\t\t@click=\"", "\">\n\t\t\t\t\t", "\n\t\t\t\t</button>\n\t\t\t\t<button class=\"bm-button primary outline md\"\n\t\t\t\t\t@click=\"", "\">\n\t\t\t\t\t", "\n\t\t\t\t</button>\n\t\t\t</footer>\n\t\t"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<bm-variable-form-new-row\n\t\t\t\t.confirmLabel=\"", "\"\n\t\t\t\t.cancelLabel=\"", "\"\n\t\t\t\t@newRowConfirm=\"", "\"\n\t\t\t\t@newRowCancel=\"", "\">\n\t\t\t\t<bm-form-container\n\t\t\t\t\t.items=\"", "\"\n\t\t\t\t\t.layout=\"", "\"\n\t\t\t\t\t.serviceRef=", "\n\t\t\t\t></bm-form-container>\n\t\t\t</bm-variable-form-new-row>\n\t\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["", ""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var BmVariableFormElement = /*#__PURE__*/function (_bmFormEventDispatche) {
  (0, _inherits2.default)(BmVariableFormElement, _bmFormEventDispatche);

  var _super = (0, _createSuper2.default)(BmVariableFormElement);

  (0, _createClass2.default)(BmVariableFormElement, [{
    key: "hideAdd",
    get: function get() {
      var hideAdd = this.info.layout.options.hideAdd;
      return !this.editable || Boolean(hideAdd);
    }
  }, {
    key: "hideRemove",
    get: function get() {
      if (!this.editable) {
        return true;
      }

      return this.info.layout.options.hideRemove;
    }
  }, {
    key: "editable",
    get: function get() {
      return !(this.info.disabled || this.info.readonly);
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-variable-form';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        info: {
          type: Object,
          attribute: false,
          reflect: false
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return _uiElements.bmButtonStyle;
    }
  }]);

  function BmVariableFormElement() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, BmVariableFormElement);
    _this = _super.call(this);
    _this.onModalAddConfirm = (0, _bind.default)(_context = _this.onModalAddConfirm).call(_context, (0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(BmVariableFormElement, [{
    key: "firstUpdated",
    value: function firstUpdated() {
      this.addEventListener('addRow', this.onAddRow);
      this.addEventListener('removeRow', this.onRemoveRow);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$info, _this$info$options;

      var valid = (_this$info = this.info) === null || _this$info === void 0 ? void 0 : (_this$info$options = _this$info.options) === null || _this$info$options === void 0 ? void 0 : _this$info$options.items;
      var items = this.info.options.items;
      items = this._hideEmptyRowErrors(items);
      var layoutInfo = this.info.layout;
      layoutInfo = this._hideAdd(layoutInfo);
      layoutInfo = this._hideRemove(layoutInfo);
      return this.html(_templateObject(), valid ? (0, _renderLayout.renderLayout)(layoutInfo, items) : null);
    }
  }, {
    key: "_hideAdd",
    value: function _hideAdd(layoutInfo) {
      if (this.hideAdd) {
        layoutInfo = dotProp.set(layoutInfo, 'options.hideAdd', true);
      }

      return layoutInfo;
    }
  }, {
    key: "_hideRemove",
    value: function _hideRemove(layoutInfo) {
      layoutInfo = dotProp.set(layoutInfo, 'options.hideRemove', this.hideRemove);
      return layoutInfo;
    }
  }, {
    key: "_hideEmptyRowErrors",
    value: function _hideEmptyRowErrors(rows) {
      var _rows = (0, _entries.default)(rows);

      var _iterator = (0, _createForOfIteratorHelper2.default)(_rows),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = (0, _slicedToArray2.default)(_step.value, 2),
              rowName = _step$value[0],
              row = _step$value[1];

          var hideErrors = (0, _bmFormValues.isEmptyForm)(row);
          rows = this.toggleHideErrors(rows, row, rowName, hideErrors);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return rows;
    }
  }, {
    key: "toggleHideErrors",
    value: function toggleHideErrors(items, item, itemName) {
      var hide = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      if (hide) {
        items = dotProp.set(items, itemName, this.hideRowErrors(item));
      } else {
        items = dotProp.set(items, itemName, this.unhideRowErrors(item));
      }

      return items;
    }
  }, {
    key: "hideRowErrors",
    value: function hideRowErrors(row) {
      var fields = this.getHideErrorFields(row);
      var c1 = {
        propPath: 'previousHideErrors',
        valuePath: 'hideErrors'
      };
      var c2 = {
        propPath: 'hideErrors',
        value: true
      };
      return (0, _bmFormEvents.applyChanges)(row, fields, c1, c2);
    }
  }, {
    key: "unhideRowErrors",
    value: function unhideRowErrors(row) {
      var fields = this.getHideErrorFields(row);
      var c1 = {
        propPath: 'hideErrors',
        valuePath: 'previousHideErrors'
      };
      return (0, _bmFormEvents.applyChanges)(row, fields, c1);
    }
  }, {
    key: "getHideErrorFields",
    value: function getHideErrorFields(row) {
      var hideErrorFields = (0, _bmFormValues.valuedFields)(row, true, row.fullyResolvedName);
      return hideErrorFields;
    }
  }, {
    key: "_addRow",
    value: function _addRow(val, mapper) {
      var layout = this.info.config.formLayout.$each.default;
      var row = (0, _variableFormFactory.makeNewVariableFormChild)(this.info.config.items, this.info, layout, mapper ? {} : val || {});

      if (mapper) {
        var changeMap = (0, _bmFormEvents.collectChanges)(row, '', val, {}, mapper);
        row = (0, _bmFormEvents.patchFormValues)(row, changeMap);
      }

      this.info.layout.options.order.push(row.name);
      this.dispatchBmFormEvent({
        type: 'changed',
        data: {
          currentValue: null,
          changes: (0, _defineProperty2.default)({}, this.info.fullyResolvedName, {
            propPath: "options.items.".concat(row.name),
            value: row
          }),
          previousValue: this.info
        }
      });
    }
  }, {
    key: "onAddRow",
    value: function onAddRow(evt) {
      var modalAdd = evt.detail.modalAdd;

      if (modalAdd) {
        this._addRowConfirm(modalAdd);
      } else {
        this._addRow();
      }

      evt.stopPropagation();
    }
  }, {
    key: "_addRowConfirm",
    value: function _addRowConfirm(_ref) {
      var _this2 = this;

      var headerLabel = _ref.headerLabel,
          confirmLabel = _ref.confirmLabel,
          cancelLabel = _ref.cancelLabel;

      var svcRefSetter = function svcRefSetter(svc) {
        _this2.modalAddSvcRef = svc;
      };

      var rowConfig = this.info.config.formLayout.$each;
      var layout;

      if (rowConfig.modalAdd) {
        layout = rowConfig.modalAdd.layout;
      } else {
        layout = rowConfig.default;
      }

      var confirmModal = this.html(_templateObject2(), confirmLabel, cancelLabel, function () {
        return _this2.onModalAddConfirm(closeModal);
      }, function () {
        return _this2.onModalAddCancel(closeModal);
      }, this.info.config.items, layout, svcRefSetter);
      var closeModal = (0, _uiElements.createModal)(confirmModal, {
        title: headerLabel,
        backdropClose: false,
        size: 'large'
      });
    }
  }, {
    key: "onModalAddConfirm",
    value: function onModalAddConfirm(closeModalCb) {
      this.modalAddSvcRef.touchForm();

      if (this.modalAddSvcRef.isValid()) {
        var modalAddConfig = this.info.config.formLayout.$each.modalAdd;
        var dataMap = modalAddConfig && modalAddConfig.dataMap;
        var modalVal = this.modalAddSvcRef.getValue();

        if (dataMap) {
          var dataMapper = function dataMapper(mapVal, _) {
            return dotProp.get(modalVal, mapVal);
          };

          this._addRow(dataMap, dataMapper);
        } else {
          this._addRow(modalVal);
        }

        closeModalCb();
      }
    }
  }, {
    key: "onModalAddCancel",
    value: function onModalAddCancel(closeModalCb) {
      closeModalCb();
    }
  }, {
    key: "onRemoveRow",
    value: function onRemoveRow(evt) {
      var _context2, _context3;

      var idx = evt.detail.idx;

      var _ref2 = (0, _splice.default)(_context2 = this.info.layout.options.order).call(_context2, idx, 1),
          _ref3 = (0, _slicedToArray2.default)(_ref2, 1),
          removedItemName = _ref3[0];

      this.info.root.dependencyMap.removeDependencies((0, _concat.default)(_context3 = "".concat(this.info.fullyResolvedName, ".")).call(_context3, removedItemName));
      var newItems = dotProp.set(this.info.options.items, removedItemName, undefined);
      delete newItems[removedItemName];
      this.dispatchBmFormEvent({
        type: 'changed',
        data: {
          currentValue: null,
          changes: (0, _defineProperty2.default)({}, this.info.fullyResolvedName, {
            propPath: 'options.items',
            value: newItems
          }),
          previousValue: this.info
        }
      });
      evt.stopPropagation();
    }
  }]);
  return BmVariableFormElement;
}((0, _bmFormEvents.bmFormEventDispatcher)(_itemRenderer.BmItemElement));

var NewRowModalElement = /*#__PURE__*/function (_BlueElement) {
  (0, _inherits2.default)(NewRowModalElement, _BlueElement);

  var _super2 = (0, _createSuper2.default)(NewRowModalElement);

  function NewRowModalElement() {
    (0, _classCallCheck2.default)(this, NewRowModalElement);
    return _super2.apply(this, arguments);
  }

  (0, _createClass2.default)(NewRowModalElement, [{
    key: "render",
    value: function render() {
      return this.html(_templateObject3(), this.confirm, this.confirmLabel, this.cancel, this.cancelLabel);
    }
  }, {
    key: "confirm",
    value: function confirm() {
      this.dispatchEvent(new CustomEvent('newRowConfirm', {
        bubbles: true,
        composed: true
      }));
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.dispatchEvent(new CustomEvent('newRowCancel', {
        bubbles: true,
        composed: true
      }));
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-variable-form-new-row';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        confirmLabel: {
          type: String,
          attribute: false,
          reflect: false
        },
        cancelLabel: {
          type: String,
          attribute: false,
          reflect: false
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return [_uiElements.bmButtonStyle, (0, _element.css)(_templateObject4())];
    }
  }]);
  return NewRowModalElement;
}(_element.BlueElement);

exports.NewRowModalElement = NewRowModalElement;

var registerBmVariableFormElement = function registerBmVariableFormElement() {
  (0, _uiElements.registerBmExpansionPanel)();
  (0, _element.register)(BmVariableFormElement);
  (0, _element.register)(NewRowModalElement);
};

exports.registerBmVariableFormElement = registerBmVariableFormElement;

var renderBmVariableForm = function renderBmVariableForm(info) {
  return (0, _element.html)(_templateObject5(), info);
};

exports.renderBmVariableForm = renderBmVariableForm;
